/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import 'primereact/resources/themes/nova-accent/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { Card } from "primereact/card";
import { Modal, Form, Col, Row, Button as ReactButton } from 'react-bootstrap';
import { handleRequest } from '../../redux/config/env';
import { Form as FormAnt } from 'antd';
import { FormattedMessage } from "react-intl";
import 'react-contexify/dist/ReactContexify.min.css';
import { Item, MenuProvider } from 'react-contexify';
import CustomMaterialMenuEditDeleteRevision from '../settings/ForComponents/CustomMaterialMenuEditDeleteRevision';
import HowtoUse from '../standardization/HowtoUse';
import Settings from '../standardization/Settings';
import Whatis from '../standardization/Whatis';
import { Table, Input, Select, InputNumber, Checkbox, Radio, Divider, DatePicker, Cascader, TimePicker, Switch, Button as AntButton, Col as ColAnt, Row as RowAnt } from 'antd';
import { Link } from 'react-router-dom';
import { NATIONALITIES, COUNTRIES } from '../settings/JsonDatas/Datas';
import moment from 'moment'
import { PlusOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { API_BASE } from '../../redux/config/env';
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { DownloadOutlined } from '@ant-design/icons';
import { setStandardization, getDynamicMenu, getUserSettings } from '../../redux/config/imu.js';
import MaskedInput from 'antd-mask-input'

const { RangePicker } = DatePicker;
const { Column } = Table;
const { Option } = Select;
const pageName = "SA175Forms";
const prefix = "175-";
const prefix2 = "IR";
export class SA175Forms extends Component {

    constructor() {
        super();
        this.state = {
            modalDeleteShow: false,
            hideInputs: true,
            hideSave: false,
            hideUpdate: true,

            id: null,
            tableList: [],
            filePath: '',
            fileList: [],
            code: '',
            revno: '',
            description: '',
            date: null,
            relatedCom: '',
            attachmentUrl: '',
            relatedComList: [],
            codeNumber:'',
            scope:'',
            testInspectionPer:'',
            testInspectionPerSelectItems:[],

            dynamicAttributes: [],
            authorizations: [],
            dynamicInputs: [],
            isAdmin: false,
            howToUseSetting: false,
            whatIsSetting: false,

            formId: 0
        };
        // this.actionTemplate = this.actionTemplate.bind(this);
        // this.showSuccess = this.showSuccess.bind(this);
        // this.showError = this.showError.bind(this);
        // this.showWarning = this.showWarning.bind(this);

    }

    formRef = React.createRef();


    componentDidMount = async () => {

        var isAdmin = false;
        let dynamicMenu = await getDynamicMenu(pageName);
        this.getUserSettings(dynamicMenu.formId);
        if (Boolean(this.props.auth) && Boolean(this.props.auth.user) && this.props.auth.user.userType === 2) {
            isAdmin = true;
        }

        let standardization = await setStandardization(pageName);
        this.setState({
            dynamicAttributes: standardization.dynamicAttributes,
            dynamicInputs: standardization.dynamicInputs,
            isAdmin: isAdmin,
            formId: dynamicMenu.formId,
            authorizations: dynamicMenu.authorizations
        })

        this.restartTable();
    }

    getUserSettings = async (formId) => {

        let userSettings = await getUserSettings(formId);
        this.setState(
            {
                howToUseSetting: userSettings.howToUseSetting,
                whatIsSetting: userSettings.whatIsSetting
            }
        )
    }

    save = async () => {

      
        let obj = {
            id: this.state.id,
            code: prefix+this.state.code,
            revno: this.state.revno,
            description: this.state.description,
            date: this.state.date,
            relatedCom: this.state.relatedCom, 
            attachmentUrl: this.state.filePath,
            codeNumber:prefix2+this.state.codeNumber,
            scope:this.state.scope,
            testInspectionPer:this.state.testInspectionPer,
        };
        console.log(obj);
        if (obj.id === null)
            await handleRequest("POST", "/Sa175Forms/add", obj);
        else
            await handleRequest("POST", "/Sa175Forms/update", obj);

        this.showSuccess();
        this.resetInputs();
        this.restartTable();

    }

    edit = (row) => {

        let code = ''; 
        if(Boolean(row.code) && row.code.length>0 && row.code.includes(prefix)) 
        code = row.code.split("-")[1]; 

        let codeNumber = ''; 
        if(Boolean(row.codeNumber) && row.codeNumber.length>0 && row.codeNumber.includes(prefix2)) 
        codeNumber = row.codeNumber.split(prefix2)[1];  

        let fileList = [];
        if(Boolean(row.attachmentUrl) && row.attachmentUrl.length>0)
        fileList =  [{
            uid:1,
            name:row.attachmentUrl,
            url:row.attachmentUrl,
            thumbUrl:row.attachmentUrl,
        }]

        this.formRef.current.setFieldsValue({
            id: row.id,
            code: code,
            revno: row.revno,
            description: row.description,
            date: moment(row.date),
            relatedCom: row.relatedCom, 
            attachmentUrl: row.attachmentUrl,
            codeNumber:codeNumber,
            scope:row.scope,
            testInspectionPer:row.testInspectionPer,
        });

        this.setState({
            id: row.id,
            code: code,
            revno: row.revno,
            description: row.description,
            date: moment(row.date),
            relatedCom: row.relatedCom,
            attachmentUrl: row.attachmentUrl,
            codeNumber:codeNumber,
            scope:row.scope,
            testInspectionPer:row.testInspectionPer,
            filePath:row.attachmentUrl,
            fileList:fileList,
            hideSave: true,
            hideUpdate: false,
            hideInputs: false,

        });

      

    }


    revision = (row) => {

        let code = ''; 
        if(Boolean(row.code) && row.code.length>0 && row.code.includes(prefix)) 
        code = row.code.split("-")[1]; 


        let codeNumber = ''; 
        if(Boolean(row.codeNumber) && row.codeNumber.length>0 && row.codeNumber.includes(prefix2)) 
        codeNumber = row.codeNumber.split(prefix2)[1];  


        let fileList = [];
        if(Boolean(row.attachmentUrl) && row.attachmentUrl.length>0)
        fileList =  [{
            uid:1,
            name:row.attachmentUrl,
            url:row.attachmentUrl,
            thumbUrl:row.attachmentUrl,
        }]

        this.formRef.current.setFieldsValue({
            id: row.id,
            code: code,
            revno: row.revno+1,
            description: row.description,
            date: moment(row.date),
            relatedCom: row.relatedCom, 
            attachmentUrl: row.attachmentUrl,
            codeNumber:codeNumber,
            scope:row.scope,
            testInspectionPer:row.testInspectionPer,
        });

        this.setState({
            id: row.id,
            code: code,
            revno: row.revno+1,
            description: row.description,
            date: moment(row.date),
            relatedCom: row.relatedCom,
            attachmentUrl: row.attachmentUrl,
            filePath:row.attachmentUrl,
            fileList:fileList,
            codeNumber:codeNumber,
            scope:row.scope,
            testInspectionPer:row.testInspectionPer,
            hideSave: true,
            hideUpdate: false,
            hideInputs: false,

        });

    }

    delete = async () => {

        const obj = {
            id: this.state.id
        }

        await handleRequest("POST", "/Sa175Forms/delete", obj);

        this.restartTable();
        this.showSuccess();
        this.showOrHideDeleteModal();
    }

    deleteModal = (row) => {
        this.setState({
            modalDeleteShow: true,
            id: row.id
        });
    }

    showOrHideDeleteModal = () => {
        this.setState({
            modalDeleteShow: !this.state.modalDeleteShow
        });

        setTimeout(() => {
            document.body.style.overflow = "auto";
            document.body.style.paddingRight = "0px";
        }, 500);
    }



    showSuccess(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageSuccess1" defaultMessage="Successfull" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Success"
        });
    }

    showError(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageError1" defaultMessage="An error was occured please try again later !" />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Error"
        });
    }

    showWarning(msg) {
        if (!msg) {
            msg = <FormattedMessage id="GeneralMessageCheckInputs" defaultMessage="Something went wrong. Please check inputs." />;
        }
        this.setState({
            modalMessage: true,
            message: msg,
            messageTip: "Warning"
        });
    };




    actionTemplate(rowData, column) {


        return <React.Fragment>
            <CustomMaterialMenuEditDeleteRevision row={rowData} onDeleteRow={this.deleteModal.bind(this)} onEditRow={this.edit.bind(this)}  onRevision= {this.revision.bind(this)} /> 
        </React.Fragment>;


    }



    restartTable = async () => {
        const response = await handleRequest("GET", "/Sa175Forms/getAllByCompany");

        if (response.data.length !== 0) {
            const list = response.data;
            list.forEach(element => {
                element.key = element.id
            });
            this.setState({
                tableList: list,
            });
        }

        if (response.data.length === 0) {
            this.setState({
                tableList: [],
            });
        }
    }



    createNew = () => {

        this.setState({
            hideInputs: !this.state.hideInputs,
            modalDeleteShow: false,
            hideSave: false,
            hideUpdate: true,
        });
        this.resetInputs();

    }


    stop = () => {

        this.setState({

            modalDeleteShow: false,
            hideInputs: true,
            hideSave: false,
            hideUpdate: true,
        });
        this.resetInputs();

    }



    resetInputs = () => {
        this.formRef.current.setFieldsValue({
            filePath: '',
            fileList: [],
            code: '',
            revno: '',
            description: '',
            date: null,
            relatedCom: '',
            attachmentUrl: '',
            codeNumber:'',
            scope:'',
            testInspectionPer:'',
        });

        this.setState({
            id:null,
            filePath: '',
            fileList: [],
            code: '',
            revno: '',
            description: '',
            date: null,
            relatedCom: '',
            attachmentUrl: '',
            codeNumber:'',
            scope:'',
            testInspectionPer:'',
            modalDeleteShow: false,
            hideSave: false,
            hideUpdate: true,


        });
    }



    cancel = () => {

        this.resetInputs();
    }


    downloadFile = async (url) => {
        window.location.href = url;
    }

    handleSearch = async (value) => {
        if(value.length>0)
       { const response = await handleRequest("GET", "/ComListing/getComs/" + value);

       console.log( response.data); 
        this.setState({
            relatedComList: Boolean(response.data) ? response.data : [],
        });} 

    }

    handleTestInspectorSearch = async (value) => {
        if(value.length>0)
       { const response = await handleRequest("GET", "/Sa175Forms/getTestInspectors/" + value);

       console.log( response.data); 
        this.setState({
            testInspectionPerSelectItems: Boolean(response.data) ? response.data : [],
        });} 

    }


    



    showOrHideModalMessage = () => {
        this.setState({
            modalMessage: !this.state.modalMessage,
        });
        setTimeout(() => {
            document.body.style.overflow = "auto";
            document.body.style.paddingRight = "0px";
        }, 500);
    }


    render() {

        const onFinish = values => {
            console.log('Success:', values);
        };

        const onFinishFailed = errorInfo => {
            console.log('Failed:', errorInfo);
        };

        const layout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };

        const props = {
            action: `${API_BASE}/File/upload`,
            listType: 'picture',
            defaultFileList: [...this.state.fileList],
        };


        return (this.state.formId > 0) ? (
            (this.state.authorizations.length > 0 && this.state.authorizations.findIndex(p => p.action === "view") >= 0)
                ? (
                    <div>
                        <MenuProvider id="menu_id">
                            <Card>
                                <div>
                                    <Row>
                                        <Col sm="1">
                                            <Settings formId={this.state.formId} onSaveChanges={this.getUserSettings.bind(this)} ></Settings>

                                        </Col>
                                        <Col sm="10">
                                        </Col>
                                        <Col sm="1" style={{ textAlign: "right" }}>
                                            {!this.state.howToUseSetting && <HowtoUse formId={this.state.formId} ></HowtoUse>}
                                        </Col>
                                    </Row>
                                </div>

                                <div>
                                    <Row>
                                        <Col sm="10">
                                        </Col>
                                        <Col sm="2">
                                            {/*<Button style={{ width: '100%' }} id='create-new' icon="pi pi-plus" onClick={this.createNew} label="Create New" />*/}
                                            {this.state.hideInputs &&
                                                <ReactButton id="OrganizationalLevelCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="primary" onClick={this.createNew}><FormattedMessage id="GeneralButtonCreateNew" defaultMessage="Create New" /></ReactButton>
                                            }

                                            {!this.state.hideInputs &&
                                                <ReactButton id="OrganizationalLevelCreateNewButton" style={{ width: '100%', marginBottom: '2rem' }} variant="danger" onClick={this.stop}><FormattedMessage id="GeneralButtonStopProcess" defaultMessage="Stop the process" /></ReactButton>
                                            }

                                        </Col>
                                    </Row>
                                </div>

                                <div hidden={this.state.hideInputs} style={{ marginBottom: '2rem' }}>

                                    <FormAnt
                                        initialValues={{ remember: false }}
                                        onFinish={this.save}
                                        onFinishFailed={onFinishFailed}
                                        ref={this.formRef}
                                    >

                                        {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175Code").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175Code" defaultMessage="Code" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="code"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Code")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175Code").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Code")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175Code").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                               
                                               <MaskedInput mask="111111"
                                                
                                                maxLength={6}  prefix={prefix} style={{ width: "50%" }} id="SA175Code" value={this.state.code} onChange={(e) => { this.setState({ code: e.target.value }) }} />

                                              

                                            </FormAnt.Item>
                                        }  {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175Revno").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175Revno" defaultMessage="Rev. No" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="revno"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Revno")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175Revno").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Revno")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175Revno").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                                <RowAnt gutter={[8, 8]}>
                                                    <ColAnt span={12}>
                                                        <InputNumber id="SA175Revno"  disabled={Boolean(this.state.id) && this.state.id > 0} placeholder="Rev. No"
                                                            min={0} value={this.state.revno} onChange={(value) => {
                                                                this.formRef.current.setFieldsValue({
                                                                    revno: value
                                                                });
                                                                this.setState({ revno: value })
                                                            }} />
                                                    </ColAnt>
                                                </RowAnt>

                                            </FormAnt.Item>
                                        }  {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175Description").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175Description" defaultMessage="SA-175 Description" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="description"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Description")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175Description").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Description")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175Description").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                                <RowAnt gutter={[8, 8]}>
                                                    <ColAnt span={12}>
                                                        <Input placeholder="SA-175 Description" style={{ width: "100%" }} id="SA175Description" value={this.state.description} onChange={(e) => { this.setState({ description: e.target.value }) }} />
                                                    </ColAnt>
                                                </RowAnt>

                                            </FormAnt.Item>
                                        }  {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175Date").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175Date" defaultMessage="Date" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="date"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Date")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175Date").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Date")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175Date").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                                <RowAnt gutter={[8, 8]}>
                                                    <ColAnt span={12}>
                                                        <DatePicker id="SA175Date" format="DD-MM-YYYY" value={this.state.date} onChange={(date, dateString) => {
                                                            this.formRef.current.setFieldsValue({
                                                                date: date
                                                            });
                                                            this.setState({
                                                                date: date
                                                            })
                                                        }} />
                                                    </ColAnt>
                                                </RowAnt>

                                            </FormAnt.Item>
                                        }  {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175CodeNumber").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175CodeNumber" defaultMessage="Code Number" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="codeNumber"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175CodeNumber")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175CodeNumber").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175CodeNumber")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175CodeNumber").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                                
                                                <MaskedInput mask="111111"                                                
                                                maxLength={6}  prefix={prefix2} style={{ width: "50%" }} id="SA175CodeNumber" value={this.state.codeNumber} onChange={(e) => { this.setState({ codeNumber: e.target.value }) }} /> 

                                            </FormAnt.Item>
                                        }  {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175RelatedCom").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175RelatedCom" defaultMessage="Related 9com#" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="relatedCom"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175RelatedCom")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175RelatedCom").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175RelatedCom")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175RelatedCom").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                                <RowAnt gutter={[8, 8]}>
                                                    <ColAnt span={12}>
                                                        <Select style={{ width: "100%" }}
                                                         showSearch
                                                         onSearch={this.handleSearch}
                                                        placeholder="Related 9com#" id="SA175RelatedCom" value={this.state.relatedCom} onChange={(value) => {
                                                            this.formRef.current.setFieldsValue({
                                                                relatedCom: value
                                                            });
                                                            this.setState({ relatedCom: value })
                                                        }}>
                                                            <Option key={null} value={null}>Select</Option>
                                                            {this.state.relatedComList.map(i => (
                                                            <Option key={i} value={i}>{i}</Option> 
                                                        ))}
                                                             </Select>
                                                    </ColAnt>
                                                </RowAnt>

                                            </FormAnt.Item>
                                        }  {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175Scope").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175Scope" defaultMessage="Scope" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="scope"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Scope")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175Scope").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Scope")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175Scope").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                                <RowAnt gutter={[8, 8]}>
                                                    <ColAnt span={12}>
                                                        <Input placeholder="Scope" style={{ width: "100%" }} id="SA175Scope" value={this.state.scope} onChange={(e) => { this.setState({ scope: e.target.value }) }} />
                                                    </ColAnt>
                                                </RowAnt>

                                            </FormAnt.Item>
                                        }  {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175TestInspectionPer").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175TestInspectionPer" defaultMessage="Test & Inspection Per" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="testInspectionPer"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175TestInspectionPer")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175TestInspectionPer").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175TestInspectionPer")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175TestInspectionPer").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                                <RowAnt gutter={[8, 8]}>
                                                    <ColAnt span={12}>
                                                        <Select style={{ width: "100%" }} placeholder="Test & Inspection Per"
                                                        showSearch
                                                        onSearch={this.handleTestInspectorSearch}
                                                        id="SA175TestInspectionPer" value={this.state.testInspectionPer} onChange={(value) => {
                                                            this.formRef.current.setFieldsValue({
                                                                testInspectionPer: value
                                                            });
                                                            this.setState({ testInspectionPer: value })
                                                        }}>
                                                            <Option key={null} value={null}>Select</Option> 
                                                            {this.state.testInspectionPerSelectItems.map(i => (
                                                            <Option key={i} value={i}>{i}</Option> 
                                                        ))}
                                                        </Select>
                                                    </ColAnt>
                                                </RowAnt>

                                            </FormAnt.Item>
                                        }  {((this.state.dynamicAttributes.length > 0 && this.state.dynamicAttributes.find(p => p.dynamicInputs.inputKey === "SA175Attachment").visible) || this.state.dynamicAttributes.length === 0) &&
                                            <FormAnt.Item
                                                {...layout}

                                                label={<FormattedMessage id="SA175Attachment" defaultMessage="Attachment" />}

                                                style={{
                                                    marginBottom: 0,
                                                }}
                                                name="attachmentUrl"
                                                rules={[{ required: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Attachment")) ? this.state.dynamicInputs.find(p => p.inputKey === "SA175Attachment").canBeRequired : false, message: Boolean(this.state.dynamicInputs.find(p => p.inputKey === "SA175Attachment")) ? <FormattedMessage id={this.state.dynamicInputs.find(p => p.inputKey === "SA175Attachment").translateRequired} defaultMessage="This field is required" /> : '' }]} >
                                                <RowAnt gutter={[8, 8]}>
                                                    <ColAnt span={12}>
                                                        <Upload {...props} id="SA175Attachment"
                                                            showUploadList={true}
                                                            fileList={this.state.fileList}
                                                            onChange={({ fileList }) => {
                                                                if (fileList.length == 1) {
                                                                    var filePath = "";
                                                                    if (Boolean(fileList[0].response)) {
                                                                        filePath = fileList[0].response.url;
                                                                        this.showSuccess("file uploaded successfully");
                                                                        // fileName: info.file.name, 
                                                                    }
                                                                    this.setState({
                                                                        fileList: fileList,
                                                                        filePath: filePath,
                                                                    });
                                                                }
                                                            }}
                                                            beforeUpload={(fileList) => {
                                                                if (this.state.fileList.length > 0) {
                                                                    this.showError("You have been already choose a file! For change firstly remove the uploaded file.");
                                                                    return false;
                                                                }
                                                                return true;
                                                            }}
                                                            onRemove={({ fileList }) => {
                                                                this.setState({
                                                                    fileList: [],
                                                                    filePath: "",
                                                                })
                                                            }
                                                            }>
                                                            <AntButton style={{ width: "100%", marginTop: "0.2rem" }}>
                                                                <UploadOutlined /> Upload
                                                            </AntButton>
                                                        </Upload>
                                                    </ColAnt>
                                                </RowAnt>

                                            </FormAnt.Item>
                                        }



                                        <div hidden={this.state.hideSave}>
                                            {
                                                <RowAnt gutter={8}>
                                                    <ColAnt span={8}></ColAnt>

                                                    <ColAnt span={8}>
                                                        {
                                                            <ReactButton id="OrganizationalLevelSaveButton" type="submit" style={{ width: '100%' }}
                                                                variant="success" ><FormattedMessage id="GeneralButtonSave" defaultMessage="Save" /></ReactButton>
                                                        }
                                                    </ColAnt>
                                                </RowAnt>

                                            }
                                        </div>



                                        <div hidden={this.state.hideUpdate}>
                                            {
                                                <Row>
                                                    <Col sm="3">
                                                    </Col>
                                                    <Col sm="2">
                                                        {/*<Button style={{ width: '100%' }} id='cancel-orgLevel' onClick={this.changeButtonCancel} className="p-button-danger" label="Cancel" />*/}
                                                        <ReactButton id="OrganizationalLevelCancelButton" style={{ width: '100%' }} variant="secondary" onClick={this.cancel}>
                                                            <FormattedMessage id="GeneralButtonCancel" defaultMessage="Cancel" /></ReactButton>
                                                    </Col>
                                                    <Col sm="3">
                                                        {/*<Button style={{ width: '100%' }} id='update-orgLevel' onClick={this.updateDone} className="p-button-warning" label="Update" />*/}
                                                        <ReactButton id="OrganizationalLevelUpdateButton" style={{ width: '100%' }} variant="warning" type="submit">
                                                            <FormattedMessage id="GeneralButtonUpdate" defaultMessage="Update" /></ReactButton>
                                                    </Col>
                                                    <Col sm="3">
                                                    </Col>
                                                </Row>
                                            }
                                        </div>
                                    </FormAnt>
                                </div>

                                {this.state.tableList.length > 0 && <Table style={{ marginTop: '3rem' }} size={`small`} dataSource={this.state.tableList} bordered scroll={{ x: 800, scrollToFirstRowOnChange: true }} >


                                    <Column title="S/N" dataIndex="index" />
                                    <Column title="Code" dataIndex="code" />
                                    <Column title="Rev No" dataIndex="revno" />
                                    <Column title="Description" dataIndex="description" />
                                    <Column title="Date" render={(value, row, index) => {

                                        if (Boolean(row.date))
                                            return moment(row.date).format("DD/MM/YYYY"); 

                                    }} />
                                    <Column title="Code Number" dataIndex="codeNumber" />
                                   
                                    <Column title="Related 9Com#" dataIndex="relatedCom" />
                                    <Column title="Scope" dataIndex="scope" />
                                    <Column title="Test Inspection Per" dataIndex="testInspectionPer" />

                                    <Column title="Attachment" render={(value, row, index) => {

                                        if (Boolean(row.attachmentUrl))
                                            return <AntButton style={{ marginLeft: '2px', marginTop: '-2px', alignContent: 'center' }} onClick={() => this.downloadFile(row.attachmentUrl)} type="primary" shape="round" icon={<DownloadOutlined />} >

                                            </AntButton>

                                    }} />
                                    <Column title="Action" render={(value, row, index) => {

                                        return this.actionTemplate(row);

                                    }} />
                                </Table>}
                            </Card>

                       </MenuProvider>
                        {!this.state.whatIsSetting && <Whatis  ></Whatis>

                        }

                        <Modal
                            show={this.state.modalDeleteShow}
                            onHide={this.showOrHideDeleteModal}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="contained-modal-title-vcenter">Chosen record will be deleted !</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>Are you sure?</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <ReactButton variant="secondary" onClick={this.showOrHideDeleteModal}>Cancel</ReactButton>
                                <ReactButton variant="danger" onClick={this.delete} >Delete</ReactButton>
                            </Modal.Footer>
                        </Modal>

                        <Modal
                            show={this.state.modalMessage}
                            onHide={this.showOrHideModalMessage}
                            backdrop="static"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered>

                            <Modal.Header closeButton>
                                <Modal.Title id="contained-modal-title-vcenter">
                                    <Row >
                                        <Col sm="12">
                                            {this.state.messageTip == "Success" &&
                                                <i className="fas fa-check fa-2x" style={{ color: '#00ff2a' }} />}

                                            {this.state.messageTip == "Warning" &&
                                                <i className="fas fa-exclamation-circle fa-2x" style={{ color: '#faca2a' }} />}

                                            {this.state.messageTip == "Error" &&
                                                <i className="fas fa-times fa-2x" style={{ color: '#ff0400' }} />}
                                        </Col>
                                    </Row>
                                </Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <Row >
                                    <Col sm="12">
                                        {this.state.message}
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <ReactButton variant="secondary" onClick={this.showOrHideModalMessage}><FormattedMessage id="GeneralTextClose" defaultMessage="Close" /></ReactButton>
                            </Modal.Footer>
                        </Modal>

                    </div>
                ) : (
                    <div>
                        <Redirect to="/error/error-v6" />
                    </div>
                )
        ) : (
                <div></div>
            );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        i18n: state.i18n
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(SA175Forms)
